/* eslint-disable */

// import Vue from 'vue';

import { createStore } from 'vuex';
import VuexPersist from 'vuex-persist';



const vuexPersist = new VuexPersist({
  key: 'my-app',
  storage: localStorage,
});

export default createStore({
  state: {
    AgentId: '',
    SessionID: '',
    TenantId: '',
    userEmail: '',
    Password: '',
    Permissions: [],
    tickets: [],
    plugins: [vuexPersist.plugin],
  },
  getters: {
    getAgentInfo(state) {
      return state;
    },
    getUserInfo(state) {
      return state;
    },
    getUserPermissions(state) {
      return state.Permissions;
    },
  },
  mutations: {
    setAgentInfo(state, payload) {
      state.AgentId = payload.AgentId;
      state.SessionID = payload.SessionID;
      state.TenantId = payload.TenantId;
    },
    setUserInfo(state, payload) {
      state.userEmail = payload.userEmail;
      state.Password = payload.Password;
      state.Permissions = payload.Permissions;
    },
    updateTickets(state, payload) {
      state.tickets = payload.tickets;
    },
  },
  actions: {

  },
});
